<div class="component-container">
  <div class="name-block mb-[5rem]">
    <div class="heading lg:w-[30%] w-[80%]">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '5rem'}"
        appearance="line"
      ></app-shimmer-loader>
    </div>
    <hr class="line mt-[0.8rem]">
    <div
      class="flex w-full justify-center items-center
           pt-[3.2rem] gap-x-[3rem] flex-col px-0
           lg:flex-row lg:px-[8rem] xs:space-x-0"
    >
      <div class="input lg:w-[50%] w-full">
        <app-shimmer-loader
          [count]="1"
          [theme]="{'height': '5rem'}"
          appearance="line"
        ></app-shimmer-loader>
      </div>
      <div class="lg:w-[50%] w-full">
        <app-shimmer-loader
          [count]="1"
          [theme]="{'height': '5rem'}"
          appearance="line"
        ></app-shimmer-loader>
      </div>
    </div>
  </div>
  <div class="group-info-block">
    <div class="heading lg:w-[30%] w-[80%]">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '5rem'}"
        appearance="line"
      ></app-shimmer-loader>
    </div>
    <hr class="line mt-[0.8rem]">
    <div class="group-info-shimmer">
      <div
        class="flex w-full justify-center items-center
            gap-x-[3rem] flex-col px-0 lg:pt-[3.2rem]
            lg:flex-row lg:px-[8rem] xs:space-x-0"
      >
        <div class="input lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
        <div class="lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
      </div>
      <div
        class="flex w-full justify-center items-center
            gap-x-[3rem] flex-col px-0 lg:pt-[3.2rem]
            lg:flex-row lg:px-[8rem] xs:space-x-0"
      >
        <div class="input lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
        <div class="lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
      </div>
      <div
        class="flex w-full justify-center items-center
            gap-x-[3rem] flex-col px-0 lg:pt-[3.2rem]
            lg:flex-row lg:px-[8rem] xs:space-x-0"
      >
        <div class="input lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
        <div class="lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
      </div>
      <div
        class="flex w-full justify-center items-center
            gap-x-[3rem] flex-col px-0 lg:pt-[3.2rem]
            lg:flex-row lg:px-[8rem] xs:space-x-0"
      >
        <div class="input lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
        <div class="lg:w-[50%] w-full">
          <app-shimmer-loader
            [count]="1"
            [theme]="{'height': '5rem'}"
            appearance="line"
          ></app-shimmer-loader>
        </div>
      </div>
    </div>
  </div>
</div>
